import React from 'react'
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

export default function Loading() {
  const classes ={
    mainBox:{
      display: 'flex',
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      height: "100vh",
      backgroundColor: 'transparent',
    }
  }
    return (
      <Box sx={classes.mainBox}>
      <Box position="relative" display="inline-flex">
        <CircularProgress sx={{color:"#5DDC9A"}} />
        <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            position="absolute"
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
         
           <Typography color="#5DDC9A" fontFamily={"Courier"} fontSize={10} fontWeight={900} sx={{mt:.5}}>乃ﾉｲ</Typography>
            
        </Box>
        </Box>
        </Box>
    )
}
